import { Button } from '@/shared/Button';
import { useContext } from 'react';
import { ExportContext } from '../ExportCompound.context';

export const DownloadMap = (): React.ReactNode => {
  const { handleDownloadMap, data } = useContext(ExportContext);

  return (
    <div className={`mt-6 ${data.graphicsMapToggle ? 'visible' : 'hidden'}`}>
      <Button onClick={handleDownloadMap}>Download map</Button>
    </div>
  );
};
